import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/houston/dynamic_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#FBFBFB",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/houston/dynamic_houston.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={697}
              height={700}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1"
          >
            <h2>
              Experience a Dynamic Feature Set with Our Custom Mobile App
              Development in Houston
            </h2>
            <p>
              Leverage our bespoke mobile app development with personalized user
              experiences. We craft applications with adaptable interface
              designs and unique functionality integration. Our end-to-end
              customization ensures scalable custom frameworks, proprietary
              algorithms, and custom API development. Therefore, our app
              developers in Houston deliver unparalleled performance and
              exclusivity for your business needs.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
